import {
	DeskNotFoundBodyComponents,
	DeskPageBodyProps,
	PageComponents
} from '@my-types';
import { React, Styled } from '@common/3rd';
import { DeskPage, DeskPageBody } from './component';

class DeskNotFoundBody extends DeskPageBody<
	DeskPageBodyProps,
	any,
	DeskNotFoundBodyComponents
> {
	protected initComponents(): DeskNotFoundBodyComponents {
		return Object.assign(
			{
				ICONS: Styled.div`
					display: flex;
					justify-content: center;
					margin-top: 40px;
					margin-bottom: 20px;
				`,
				ICON: Styled.span`
					background: linear-gradient(315deg, 
						${props => props.theme.COLOR_PRIMARY},
						${props => props.theme.COLOR_PRIMARY} 35%,
						${props => props.theme.COLOR_PRIMARY_LIGHT} 100%,
						${props => props.theme.COLOR_PRIMARY_LIGHT});
					color: ${props => props.theme.COLOR_REVERSED};
					text-align: center;
					border-radius: 100%;
					height: 150px;
					line-height: 150px;
					width: 150px;
					font-size: 72px;
					font-weight: bold;
					margin-right: 5px;
					box-shadow: 3px 3px 3px rgb(0, 0, 0, 0.3);
				`,
				MSG: Styled.div`
					text-align: center;
					font-weight: bold;
				`
			},
			super.initComponents()
		);
	}
	render() {
		const C = this.getComponents();
		return (
			<C.Box>
				<C.ICONS>
					<C.ICON>4</C.ICON>
					<C.ICON>0</C.ICON>
					<C.ICON>4</C.ICON>
				</C.ICONS>
				<C.MSG>
					您访问的页面放假旅游了, 请联系系统管理员让他回来干活.
				</C.MSG>
			</C.Box>
		);
	}
}

/**
 * 桌面404页面
 */
class DeskNotFound extends DeskPage<any, any, PageComponents> {
	renderPageBody() {
		return <DeskNotFoundBody />;
	}
}

export default DeskNotFound;
export { DeskNotFoundBody };
